import {environment} from '../config'
const {REACT_APP_SERVER_URL, REACT_APP_SERVER_URL_SOFIA, REACT_APP_API_NIVELES_MATERIAS_OBJETIVOS, REACT_APP_API_OAS_TP, REACT_APP_API_OAS} = environment;
export const baseApiURL = REACT_APP_SERVER_URL;
export const baseUrlSofia = REACT_APP_SERVER_URL_SOFIA;
export const baseUrlNivelesMateriasObjetivos = REACT_APP_API_NIVELES_MATERIAS_OBJETIVOS;
export const baseOASOrganizacion = REACT_APP_API_OAS;
export const baseOASTP = REACT_APP_API_OAS_TP;